<template>
  <v-data-table
    :headers="prop_headers"
    :items="prop_items"
    class="elevation-1"
    :loading="propsLoading"
    loading-text="Загружаю данные"
    item-key="PROP_ID"
    show-select
    single-select
    :search="propSearch"
    :value="value"
    @input="setValue"
    locale="ru-RU"
    dense
  >
    <template v-slot:top>
      <v-toolbar color="primary" dark dense>
        <v-toolbar-title>Свойства компонента</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="propSearch"
          append-icon="mdi-magnify"
          label="Искать"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:no-data>
      Нет данных
    </template>
    <template v-slot:[`item.CURR_PROP_VALUE`]="{ item }">
      <v-btn icon x-small class="red darken-4" v-if="!item.CURR_PROP_VALUE">
        <v-icon class="white--text">mdi-exclamation-thick</v-icon>
      </v-btn>
      <div v-else>{{ numLocaleDecorator(item.CURR_PROP_VALUE) }}</div>
    </template>
  </v-data-table>
</template>

<script>
import { RCPT_GET_COMP_PROPERTIES } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'

export default {
  name: 'componentPropertiesTable',
  props: ['value', 'component'],
  mixins: [numDecorator],
  components: {
  },
  data () {
    return {
      prop_headers: [
        { text: 'Свойство', align: 'center', value: 'PROP_NAME' },
        // { text: 'Мин', align: 'start', value: 'PROP_MIN' },
        // { text: 'Макс', value: 'PROP_MAX' },
        // { text: 'Коэффициенты', value: 'PROP_KOEFF' },
        { text: 'Значение', align: 'end', value: 'CURR_PROP_VALUE' },
        { text: 'Ед.изм.', align: 'start', value: 'MU_TXT_NAME' }
      ],
      propsLoading: false,
      propSearch: '',
      selectedProp: [],
      prop_items: []
    }
  },
  watch: {
    component (val) {
      console.log('componentPropertiesTable component watcher detected component change to ', val)
      if (!val || !val.length || !val[0].COMP_ID || !val[0].ULF_ID) {
        console.log('clearing data')
        this.setValue([])
        this.prop_items.splice(0, this.prop_items.length)
      } else {
        console.log('requesting data')
        this.getPropList()
      }
    },
    value (val) {
      console.log('componentPropertiesTable value watcher detected value change to ', val)
      if (!val || !val.length || !val[0].PROP_ID) return
      const curr = this.prop_items.findIndex(itm => itm.PROP_ID === val[0].PROP_ID)
      if (curr >= 0) {
        this.prop_items.splice(curr, 1, val[0])
      } else {
        this.prop_items.push(val[0])
      }
    }
  },
  computed: {
  },
  mounted: function () {
    if (this.prop_items.length === 0 && this.component && this.component.length) {
      this.getPropList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getPropList () {
      const self = this
      this.propLoading = true
      this.$store.dispatch(RCPT_GET_COMP_PROPERTIES, { COMP_ID: this.component[0].COMP_ID, ULF_ID: this.component[0].ULF_ID })
        .then((res) => {
          self.prop_items.splice(0, self.prop_items.length, ...res)
          self.setValue([])
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
        })
        .finally(() => {
          self.propLoading = false
        })
    }
  }
}
</script>
